import Head from 'next/head'

type SchemaObject = {
  '@type': string
} & any

interface Props {
  schemaObject: SchemaObject
}

const Schema = ({ schemaObject }: Props): React.ReactElement => {
  return (
    <Head>
      <script dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaObject) }} type="application/ld+json" />
    </Head>
  )
}

export default Schema
